import React, { useEffect, useRef } from 'react';
import styled from '@emotion/styled';
import { mq } from 'style/variables';
import { text, contentWrapper } from 'style/mixin';
import sizes from 'style/sizes';
import colors from 'style/colors';
import { EnHeading } from 'components/atoms/enHeading';
import { Dl } from 'components/atoms/dl';
import { Award, AwardProps } from 'components/atoms/award';
import fonts from 'style/fonts';
type ProjectDetailOtherDataProps = {
  client?: string;
  credit?: Array<CreditObject>;
  partner?: Array<CreditObject>;
  awards?: Array<AwardProps>;
  isNewLayout?: boolean;
};

export type CreditObject = {
  title: string;
  data: string;
};

const Container = styled.div`
  margin-bottom: ${sizes.margin[180]};
  padding: ${sizes.margin[120]} 0;
  background-color: ${colors.gray02};
  ${mq.onlysp} {
    padding: ${sizes.margin[100]} 0;
    margin-bottom: ${sizes.margin[100]};
  }
`;

const Col = styled.div`
  ${contentWrapper}
  ${mq.onlypc} {
    display: flex;
  }
  &:not(:last-of-type) {
    margin-bottom: ${sizes.margin[64]};
  }
`;

const Title = styled.div`
  ${mq.onlypc} {
    min-width: 230px;
  }
  ${mq.onlysp} {
    margin-bottom: 36px;
  }
`;

const ColInner = styled.div`
  font-family: ${fonts.jaGothic};
  width: 100%;
  ${mq.onlysp} {
    ${text(15, 2.13)};
    font-weight: 400; // textのmixinによってweightが上書きされるためさらに上書き
    letter-spacing: 0.6px;
  }
`;

const Credits = styled.div`
  font-family: ${fonts.jaGothic};
  ${text(15, 2)}
  dl {
    dt {
      ${mq.onlysp} {
        max-width: 123px;
        min-width: 123px;
      }
    }
  }
`;

const Awards = styled.ul`
  display: flex;
  flex-wrap: wrap;
  ${mq.onlypc} {
    margin-top: -${sizes.margin[96]};
  }
  ${mq.onlysp} {
    margin-bottom: -${sizes.margin[49]};
  }
  & > li {
    width: 25%;
    ${mq.onlypc} {
      padding-right: 20px;
      margin-top: ${sizes.margin[96]};
    }
    ${mq.onlysp} {
      padding-right: 10px;
      width: 50%;
      margin-bottom: ${sizes.margin[49]};
    }
  }
`;

export const ProjectDetailOtherData: React.FC<ProjectDetailOtherDataProps> = props => {
  const credits = useRef<HTMLDivElement>(null);
  const partners = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const dt = credits?.current?.querySelectorAll('dt');
    if (!dt) return;
    const dtwidth = Array.from(dt)?.map(el => el.clientWidth);
    const maxWidth = Math.max.apply(null, dtwidth);

    Array.from(dt)?.forEach(el => {
      el.style.width = `${maxWidth + 20}px`;
    });
  }, [credits]);

  useEffect(() => {
    const dt = partners?.current?.querySelectorAll('dt');
    if (!dt) return;
    const dtwidth = Array.from(dt)?.map(el => el.clientWidth);
    const maxWidth = Math.max.apply(null, dtwidth);

    Array.from(dt)?.forEach(el => {
      el.style.width = `${maxWidth + 20}px`;
    });
  }, [partners]);

  return (
    <Container>
      {props.client && (
        <Col>
          <Title>
            <EnHeading size={'middle'}>Client</EnHeading>
          </Title>
          <ColInner>
            <p>{props.client}</p>
          </ColInner>
        </Col>
      )}
      {props.credit && (
        <Col>
          <Title>
            <EnHeading size={'middle'}>Credit</EnHeading>
          </Title>
          <ColInner>
            <Credits ref={credits}>
              {props.credit?.map((item, idx) => (
                <Dl key={idx} title={item.title} data={item.data}></Dl>
              ))}
            </Credits>
          </ColInner>
        </Col>
      )}
      {props.partner && (
        <Col>
          <Title>
            <EnHeading size={'middle'}>Partner</EnHeading>
          </Title>
          <ColInner>
            <Credits ref={partners}>
              {props.partner?.map((item, idx) => (
                <Dl key={idx} title={item.title} data={item.data}></Dl>
              ))}
            </Credits>
          </ColInner>
        </Col>
      )}
      {props.awards && !props.isNewLayout && (
        <Col>
          <Title>
            <EnHeading size={'middle'}>Awards</EnHeading>
          </Title>
          <ColInner>
            <Awards>
              {props.awards?.map((item, idx) => (
                <li key={idx}>
                  <Award award={item.award} win={item.win} to={item.to} label={item.label}></Award>
                </li>
              ))}
            </Awards>
          </ColInner>
        </Col>
      )}
    </Container>
  );
};
